export enum ElementTypes {
  StaticText = 'StaticText',
  StaticAttachment = 'StaticAttachment',
  FieldText = 'FieldText',
  FieldLongText = 'FieldLongText',
  FieldPhone = 'FieldPhone',
  FieldEmail = 'FieldEmail',
  FieldAutoNumber = 'FieldAutoNumber',
  FieldFormula = 'FieldFormula',
  FieldNumber = 'FieldNumber',
  FieldCollaborator = 'FieldCollaborator',
  FieldCurrency = 'FieldCurrency',
  FieldDateTime = 'FieldDateTime',
  FieldStatus = 'FieldStatus',
  FieldSelect = 'FieldSelect',
  FieldMultiSelect = 'FieldMultiSelect',
  FieldMultiAttachment = 'FieldMultiAttachment',
  FieldCheckbox = 'FieldCheckbox',
  FieldRating = 'FieldRating',
  FieldRecordRef = 'FieldRecordRef',
  FieldLookup = 'FieldLookup',
  FieldRollup = 'FieldRollup',
  FieldUnsupported = 'FieldUnsupported',
  FieldSubtable = 'FieldSubtable'
}
